export enum FontVisibility {
    INACTIVE = 0,
    STAFF_ONLY = 1,
    WITH_LINK = 2,
    EVERYONE = 3,
    PREVIEW_ONLY = 4,
}
